// stores/counter.js
import { defineStore } from 'pinia'

export const useConfigStore = defineStore('config', {
  state: () => {
    return { 
        
        token:'',
    
    }
  },
  // could also be defined as
  // state: () => ({ count: 0 })
  actions: {
    set(data) {
      this.baseapi=data;
    },
  },
})